
import {
    defineComponent,
    onMounted,
    ref
} from "vue";

export default defineComponent({
    name: "VideoTest",
    setup(props, ctx) {
        let videoRef: any = ref(null);
        let showPlayBtnFlag = ref(true);
        const startPlay = () => {
            showPlayBtnFlag.value = false;
            videoRef.value.play();
        };

        let showShowBtnFlag = ref(false);
        let showCodeFlag = ref(false);
        let layerOpenFlag = ref(false);
        const timeUpdate = (event: any) => {
            let timeCurr = event.srcElement.currentTime;

            if (timeCurr > 3.6 && !layerOpenFlag.value) {
                layerOpenFlag.value = true;

                showShowBtnFlag.value = true;
            }
        };

        return {
            videoRef,
            showPlayBtnFlag,
            showShowBtnFlag,
            showCodeFlag,
            startPlay,
            timeUpdate
        };
    }
});
